import {UUID} from '../../../shared/types/uuid.type';
import {createAction, props} from '@ngrx/store';

const prefix = '[StopManyDestinations] ';

export const stopManyDestinations = createAction(
  `${prefix} Stop Many Destinations`,
  props<{ ids: UUID[] }>()
);

export const stopManyDestinationsSuccess = createAction(
  `${prefix} Stop Many Destinations Success`,
  props<{ ids: UUID[] }>()
);

export const stopManyDestinationsFailure = createAction(
  `${prefix} Stop Many Destinations Failure`,
  props<{ error: any }>()
);

export const clearStopManyDestinationsState = createAction(
  `${prefix} Clear Stop Many Destinations State`
);
